import React from 'react';
import './style.scss';
import ClientLogo from '../../../../components/ClientLogo/ClientLogo';
import { useTranslation } from 'react-i18next';

const PdfHeader: React.FC<{
  assetName: string;
  date: string;
  category: string;
  assetDescription?: string;
}> = ({ assetName, date, category, assetDescription }) => {
  const { t } = useTranslation();
  return (
    <header className="pdf-header" data-testid="pdf-header">
      <div className="pdf-header-title">
        <ClientLogo />
        <strong className="with-divider">{t('pdf:headerTitle')}</strong>
        <span> {t(`pdf:category.${category}`)}</span>
      </div>
      <div className="pdf-header-aside">
        <strong className="with-divider">{`${assetName} - ${assetDescription}`}</strong>
        <span>{date}</span>
      </div>
    </header>
  );
};

export default PdfHeader;
